import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Main from "./pages/Main";
import Collection from "./components/Collection";
import User from "./components/User";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/home" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/collection" element={<Collection />} />
      <Route path="/user" element={<User />} />
    </Routes>
  );
}

export default App;
